<!-- eslint-disable max-len -->
<template>
  <div class="row form-page-detail--body">
    <b-col cols="12">
      <div class="section-container">
        <h6 class="font-weight-bold">General Information</h6>
        <b-form-group :class="{'error-input' : $v.dataSetup.name.$error}">
          <label> AI Model Name </label>
          <j-input v-model="$v.dataSetup.name.$model"/>
        </b-form-group>

        <label> AI Purpose </label>
        <div
          class="container-type-list-options"
          style="justify-content: left">
          <div
            :class="typeMode === 'classification' ? 'option-active' : ''"
            class="container-option text-align-center"
            @click="typeMode = 'classification'">
            <span class="text-option">Classification</span>
          </div>
          <div
            :class="typeMode === 'regression' ? 'option-active' : ''"
            class="container-option text-align-center"
            @click="typeMode = 'regression'">
            <span class="text-option">Regression</span>
          </div>
          <div
            :class="typeMode === 'clustering' ? 'option-active' : ''"
            class="container-option text-align-center"
            @click="typeMode = 'clustering'">
            <span class="text-option">Clustering</span>
          </div>
        </div>

        <b-form-group>
          <label> Dataset </label>
          <j-input
            v-model="formData.name"
            :disabled="true" />
        </b-form-group>
      </div>

      <div class="section-container">
        <h6 class="font-weight-bold">Provider</h6>
        <b-form-group :class="{'error-input' : $v.dataSetup.connection_name.$error}">
          <label>Third Party</label>
          <j-single-select
            v-model="$v.dataSetup.connection_name.$model"
            :options="listThirdParty"
            placeholder="Select Third Party"
            label="label"/>
        </b-form-group>
      </div>

      <div class="section-container">
        <h6 class="font-weight-bold">Target Class</h6>
        <b-form-group :class="{'error-input' : $v.dataSetup.target_class.$error}">
          <label>Column</label>
          <j-single-select
            v-model="$v.dataSetup.target_class.$model"
            :options="listTargetClass"
            placeholder="Select Column"
            label="label"/>
        </b-form-group>
      </div>
    </b-col>
  </div>
</template>

<script>
/* eslint-disable max-len, no-nested-ternary, no-console, camelcase, no-unused-vars */
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapState, mapMutations } from 'vuex';
import jwtDecode from 'jwt-decode';

export default {
  components: {
  },
  validations() {
    const validate = {
      dataSetup: {
        name: {
          required,
        },
        connection_name: {
          required,
        },
        target_class: {
          required,
        },
      },
    };
    return validate;
  },
  props: {
    aiDetail: {
      type: Object,
      default: () => {},
    },
    formData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dataSetup: {
        name: null,
        connection_name: null,
        target_class: null,
      },
      typeMode: 'classification',
      listThirdParty: [],
      listTargetClass: [],
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },
  computed: {
    ...mapState('jStoreThirdParty', ['list_connection']),
  },
  watch: {
    list_connection(val) {
      this.listThirdParty = val.map(el => ({
        id: el.connection_name,
        label: el.connection_name,
      }));
    },
  },
  created() {
    if (this.aiDetail) {
      this.dataSetup.name = this.aiDetail.name;
      this.dataSetup.connection_name = this.aiDetail.connection_name || null;
      this.dataSetup.target_class = this.aiDetail.target_class || null;
      this.typeMode = this.aiDetail.purpose;
    }
    this.getDataProvider();
    this.mapListColumn();
  },
  methods: {
    ...mapActions('jStoreAi', ['updateAi']),
    ...mapActions('jStoreThirdParty', ['getListThirdPartyConnection']),
    ...mapMutations('jStoreFormUi', ['setChangesValueView']),

    getDataProvider() {
      const dataFilter = {
        type: 'driver_ai',
      };
      const params = {
        limit: 50,
        page: 1,
        sort: { created_at: -1 },
        filter: JSON.stringify(dataFilter),
      };
      this.getListThirdPartyConnection(params);
    },

    mapListColumn() {
      const listColumns = Object.keys(this.formData.columns);
      this.listTargetClass = [];

      if (listColumns.length > 0) {
        listColumns.forEach((column) => {
          this.listTargetClass.push({
            id: column,
            label: column,
          });
        });
      }
    },

    async submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        this.$swal({
          title: 'Update',
          text: `Are you sure to update ${this.aiDetail.name}?`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Update',
          confirmButtonColor: '#42a5ce',
          cancelButtonColor: '#D2232A',
          titleColor: '#D2232A',
        }).then(async (result) => {
          if (result.value) {
            const params = {
              id: this.aiDetail.id,
              name: this.dataSetup.name,
              purpose: this.typeMode,
              connection_name: this.dataSetup.connection_name || '',
              target_class: this.dataSetup.target_class || '',
            };
            const res = await this.updateAi(params);
            if (!res.error) {
              this.setChangesValueView(false);
            }
          }
        });
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/ai/menu/jMenuInfo.vue